import React, { Component } from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Plot from "../../utils/customPlotly";
import { dtickFormat } from "../../utils/constants";
import moment from "moment";

class RecentEOActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      yRange: [-0.15, 1],
      actionCount: this.props.actionCount,
      isAllEOPage: this.props.eo_id == null ? true : false,
      dTickFormatType: null,
      xMinDate: null,
    };

    //  console.log(this.props)
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats();
    }
  }

  componentDidMount() {
    this.getActionStats();
  }

  getActionStats = () => {
    // console.log('called!')
    let { yRange } = this.state;
    let { xAxisByMonth } = this.props;
    let params = {
      enterpriseId: this.props.eo_id,
      isByMonth: xAxisByMonth,
    };
    axios
      .get(url.latestObjectiveActivity, {
        params: params,
      })
      .then(result => {
        // console.log('recent---',  result)
        let data = result.data.data;
        let chartData,
          yMax = 0,
          xMinDate,
          xMaxDate,
          plotlyDTick;

        if (data && data.length > 0) {
          let yaxis = data.map(e => {
            if (e.count > yMax) {
              yMax = e.count;
            }
            return e.count;
          });

          let x = data.map(kpi => {
            let date1 = kpi.isoDate;
            if (xMinDate == undefined || xMinDate > date1) {
              xMinDate = date1;
            }

            if (xMaxDate == undefined || date1 > xMaxDate) {
              xMaxDate = date1;
            }
            // console.log(moment.utc(kpi.isoDate).format('YYYY-MM-DD'), '--------',moment(kpi.isoDate))
            return kpi.isoDate;
          });

          plotlyDTick = dtickFormat(xMinDate, xMaxDate, x.length);
          // console.log(plotlyDTick)
          chartData = [
            {
              // x: data.map(e=> `${e._id.year}-${e._id.month}-${e._id.day}`),
              x,
              y: yaxis,
              type: "scatter",
              hovertemplate:
                "%{x|%b %e, %Y} " + ` <br>count: %{y:.0}` + "<extra></extra>",
            },
          ];
        } else {
          chartData = false;
        }
        // console.log('dtick type--', plotlyDTick)
        this.setState({
          chartData,
          yRange: [0, yMax + 5],
          dTickFormatType: plotlyDTick,
          xMinDate,
        });
      });
  };

  render() {
    let { yRange, chartData, isAllEOPage, dTickFormatType, xMinDate } =
      this.state;
    // let{xAxisByMonth}= this.props
    // console.log(xMinDate)
    if (chartData && chartData.length > 0) {
      return (
        <div>
          <Plot
            data={chartData}
            layout={{
              showlegend: false,
              autosize: true,
              pull: [0.8, 0, 0],
              uirevision: true,
              // legend: {
              //   bgcolor:'white',
              //   xanchor: "left",
              //   // y:yLegend,
              //   x:0
              // },
              paper_bgcolor: "#F3F3F4",
              plot_bgcolor: "#F3F3F4",
              margin: {
                l: 20,
                r: 20,
                b: 10,
                t: 20,
                pad: 15,
              },
              xaxis: {
                showgrid: false,
                // fixedrange:true,
                type: "date",
                automargin: true,
                // tick0:xMinDate,
                // ticklabelmode:'period',
                dtick: dTickFormatType,
                tickformat: isNaN(dTickFormatType / 86400000)
                  ? "%b<br>%Y"
                  : "%b %e",
                // dtick:xAxisByMonth?"M1":null,
                // tickformat: xAxisByMonth?'%b %Y':'%b %e, %Y',
                // rangeslider: {},
                tickfont: { color: "#313236" },
                title: {
                  // text: 'Date',
                  text: isNaN(dTickFormatType / 86400000)
                    ? `Date`
                    : `Date (${moment(xMinDate).format("YYYY")})`,
                  standoff: 15,
                },
              },
              yaxis: {
                zerolinecolor: "#ffffff",
                zerolinewidth: 1,
                gridcolor: "#ffffff",
                gridwidth: 2,
                // tickformat: yTickFormat,
                tickfont: { color: "#313236" },
                fixedrange: true,
                automargin: true,
                title: {
                  text: "# of Actions",
                  standoff: 20,
                },
                range: yRange,
                rangemode: "tozero",
              },
              hovermode: "closest",
            }}
            scrollZoom={true}
            // config={{displayModeBar:false}}
            config={{
              scrollZoom: true,
              modeBarButtonsToRemove: ["pan2d", "select2d", "lasso2d"],
              // modeBarButtonsToAdd:['drawline',
              //                           'drawopenpath',
              //                           'drawclosedpath',
              //                           'drawcircle',
              //                           'drawrect',
              //                           'eraseshape',
              //                         ],
              displaylogo: false,
              responsive: true,
              toImageButtonOptions: {
                format: "png", // one of png, svg, jpeg, webp
                // moment(d.createdDate).format('MM/DD/YYYY')
                filename: `Latest Objective Activity - ${moment(
                  new Date()
                ).format("MM-D-YYYY")}`,
                height: 600,
                width: null,
                scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
              },
            }}
            className="recentActivity plotlyChart"
          />
        </div>
      );
    } else {
      return (
        <span>
          <div
            className={isAllEOPage ? "actionStatsNA mt12p" : "actionStatsNA"}
          >
            {" "}
            No Activity{" "}
          </div>
          <p className="actionStatsNAsubtitle">
            available on {isAllEOPage ? "objectives" : "this objective"}
          </p>
        </span>
      );
    }
  }
}

export default RecentEOActivity;
